import { render, staticRenderFns } from "./Workshop_brunei.vue?vue&type=template&id=9c985cc8&"
import script from "./Workshop_brunei.vue?vue&type=script&lang=js&"
export * from "./Workshop_brunei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports